import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { handleApiError } from 'src/app/shared/utils';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RfqService {
  baseUrl = environment.BASE_URL;

  sendPoApi = `${this.baseUrl}rfq/common/send-po`;
  getRfqApi = `${this.baseUrl}rfq/customer/rfq/get`;
  sendPdcApi = `${this.baseUrl}v2/rfq/customer/uploadPDC`;
  constructor(private http: HttpClient) { }
   
  draftRfqPopupClicked:any;
  showDraftMessage: boolean = true;
  
  
  setValue(value: any) {
    this.draftRfqPopupClicked = value;
  }
  getValue() {
    return this.draftRfqPopupClicked;
  }
  updatePoData(payload: any) {
    return this.http
      .put(this.sendPoApi, payload)
      .pipe(catchError((err) => handleApiError(err)));
  }
  updatePDCData(payload: any) {
    return this.http
      .post(this.sendPdcApi, payload)
      .pipe(catchError((err) => handleApiError(err)));
  }
  getCustomerRfq(rfqId:number){
    return this.http.get(`${this.getRfqApi}/${rfqId}`).pipe(catchError((err) => handleApiError(err)))
  }

}
